import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePropsContext } from '@uhg-abyss/web/hooks/usePropsContext';
import { config } from '@uhg-abyss/web/tools/config';
import { storage } from '@uhg-abyss/web/tools/storage';
import { event } from '@uhg-abyss/web/tools/event';
import { IdleTimer } from './IdleTimer';
import { IdleModal } from './IdleModal';
import { RecoveryModal } from './RecoveryModal';
import { HAS_SIGNED_OUT } from './constants';
import { dispatchEvent } from '@uhg-abyss/parcels/tools/dispatchEvent';

export const IdleUser = ({ isModalOpen }) => {
  const { data, events } = usePropsContext();
  const [idleModalOpen, setIdleModalOpen] = useState(false);
  const [recoveryModalOpen, setRecoveryModalOpen] = useState(false);
  const isDisabled = config('DISABLE_IDLE_TIMEOUT');
  const showRecovery = !events.showIdleRecovery || events('showIdleRecovery');

  useEffect(() => {
    if (showRecovery && storage.local.get(data.idleStorageKey)) {
      setRecoveryModalOpen(true);
    }
  }, [showRecovery]);

  useEffect(() => {
    storage.local.set(HAS_SIGNED_OUT, false);
  }, []);

  const onIdle = () => {
    dispatchEvent('togglePayer', false);
    dispatchEvent('toggleProvider', false);
    setIdleModalOpen(true);
    event('IDLE_MODAL_OPEN', {
      modalName: 'Session Timeout Modal',
    });
  };

  const closeIdleModal = () => {
    setIdleModalOpen(false);
    event('IDLE_MODAL_CLICK', {
      interactionName: 'Session Timeout',
      interactionValue: 'Continue Working',
      interactionContext: 'Session Timeout Warning Modal',
    });
    event('IDLE_MODAL_CLOSE', {
      modalName: 'Session Timeout Modal',
    });
  };

  return isDisabled ? null : (
    <IdleTimer
      modalOpen={idleModalOpen || isModalOpen}
      idleTimeout={data.idleTimeout}
      onIdle={onIdle}
    >
      <IdleModal
        timeRemaining={data.timeRemaining}
        isOpen={idleModalOpen || isModalOpen}
        closeModal={closeIdleModal}
      />
      <RecoveryModal
        idleStorageKey={data.idleStorageKey}
        isOpen={recoveryModalOpen && !idleModalOpen}
        closeModal={() => setRecoveryModalOpen(false)}
      />
    </IdleTimer>
  );
};

IdleUser.propTypes = {
  isModalOpen: PropTypes.bool,
};

IdleUser.defaultProps = {
  isModalOpen: false,
};
